import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TermsComponent } from './terms/terms.component';
import { PrivacyComponent } from './privacy/privacy.component';
import { ErrorComponent } from './error/error.component';
import { AuthCallbackComponent } from './auth-callback/auth-callback.component';
import { authGuard } from './guards/auth.guard';


const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'login' },
  {
    path: 'home',
    loadChildren: () => import('./home/home.module').then(m => m.HomeModule),
    canActivate: [authGuard],
    data: {
      roles: [],
    },
  },
  {
    path: 'about',
    loadChildren: () => import('./productionApps/ews/ews.module').then(m => m.EwsModule),
    canActivate: [authGuard],
    data: {
      roles: [],
    }
  },
  {
    path: 'ews',
    loadChildren: () => import('./productionApps/ews/ews.module').then(m => m.EwsModule),
    canActivate: [],
    data: {
      roles: [],
    }
  },
  {
    path: 'terms',
    component: TermsComponent,
    canActivate: [authGuard],
    data: {
      roles: [],
    }
  },
  {
    path: 'privacy',
    component: PrivacyComponent,
    canActivate: [],
    data: {
      roles: [],
    }
  },
  {
    path: 'error',
    component: ErrorComponent,
    canActivate: [],
    data: {
      roles: [],
    }
  },
  {
    path: 'login',
    loadChildren: () => import('./login/login.module').then(m => m.LoginModule),
    canActivate: [],
    data: {
      roles: [],
    }
  },
  {
    path: 'auth/callback/:provider',
    component: AuthCallbackComponent,
    canActivate: [],
    data: {
      roles: [],
    }
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
